<div class="timestamp">
	<span>{{ callEvent.callDate | date: "HH:mm" }}</span>
</div>
<div class="room">
	<div class="name" [innerHTML]="callEvent.location"></div>
	@if (callEvent.suggestions.length !== 0) {
		<div class="residents">
			<p>
				{{ suggestions }}
			</p>
		</div>
	}
</div>
<div class="open">
	@if (!callEvent.cancelDate) {
		<i class="fa fa-bell"></i>
	}
</div>
@if (alarmsPermission) {
	<div>
		<i class="fa fa-angle-right"></i>
	</div>
}
